<script setup lang="ts">
import { useGeoDataStore } from '~/stores/geoData'
import { Municipality, RegionPages } from '@/types/types'
import AppLoadingWrapper from '~/components/app/AppLoadingWrapper.vue'
definePageMeta({
  layout: 'full-width',
})

const { slug } = useRoute().params
const geoDataStore = useGeoDataStore()
const municipality = computed<Municipality | undefined>(() => {
  return geoDataStore.municipalities.find((m) => m.slug === slug)
})
const pageMunicipality = computed<RegionPages>(() => geoDataStore.pageMunicipality)

onMounted(() => {
  geoDataStore.initMunicipalities()
  geoDataStore.initPageMunicipality()
})
useSeoMeta({
  title: () =>
    `Drivmedla - ${
      municipality.value ? `Omställningskarta ${municipality.value.name}` : 'Omställningskarta'
    }`,
  description: () =>
    `Här finns karta och statistik för ${
      municipality.value ? municipality.value.name : 'regioners'
    } omställning till fossilfria alternativ`,
  ogTitle: () =>
    `Drivmedla - ${
      municipality.value ? `Omställningskarta ${municipality.value.name}` : 'Omställningskarta'
    }`,
  ogDescription: () =>
    `Här finns karta och statistik för ${
      municipality.value ? municipality.value.name : 'regioners'
    } omställning till fossilfria alternativ`,
  ogLocale: () => 'sv_SE',
  ogSiteName: () => 'Drivmedla',
  ogUrl: () => `${useRuntimeConfig().public.baseURL}${useRoute().fullPath}`,
  ogImage: () => `${useRuntimeConfig().public.baseURL}/_nuxt/assets/_logo-horizontal-GREEN.svg`,
})
</script>

<template>
  <AppLoadingWrapper :is-loading="!municipality" :height="20">
    <RegionView
      v-if="municipality"
      region-type="municipality"
      :region-id="municipality.municipality_code"
      :region-object="municipality"
      :region-content="pageMunicipality"
    />
  </AppLoadingWrapper>
</template>
<style scoped></style>
